/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  CreateSupportCaseErrorResponse,
  CreateSupportCaseRequest,
  CreateSupportCaseResponse,
} from './api.schemas';

import { api } from '../util/http';

export const createSupport = (
  createSupportCaseRequest: CreateSupportCaseRequest,
  signal?: AbortSignal,
) => {
  return api<CreateSupportCaseResponse>({
    url: `/api/support`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSupportCaseRequest,
    signal,
  });
};

export const getCreateSupportMutationOptions = <
  TError = CreateSupportCaseErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupport>>,
    TError,
    { data: CreateSupportCaseRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupport>>,
  TError,
  { data: CreateSupportCaseRequest },
  TContext
> => {
  const mutationKey = ['createSupport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupport>>,
    { data: CreateSupportCaseRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createSupport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupportMutationResult = NonNullable<Awaited<ReturnType<typeof createSupport>>>;
export type CreateSupportMutationBody = CreateSupportCaseRequest;
export type CreateSupportMutationError = CreateSupportCaseErrorResponse;

export const useCreateSupport = <TError = CreateSupportCaseErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSupport>>,
      TError,
      { data: CreateSupportCaseRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSupport>>,
  TError,
  { data: CreateSupportCaseRequest },
  TContext
> => {
  const mutationOptions = getCreateSupportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
